import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import LmLoader from "./Lm-Loader";
import Loading from "../beta/components/helpers/Loading";
import { requestWithHeaders } from "../beta/utils/fetchData";
import { checkForXSS, safeRedirect } from "../beta/utils/queryStringHelper";

const ForgotPassword = () => {
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [errors, setErrors] = useState([]);
    const [antiforgeryToken, setAntiforgeryToken] = useState("");
    const [emailSent, setEmailSent] = useState(false);
    const [username, setUsername] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [isCheckingAuth, setIsCheckingAuth] = useState(false);

    useEffect(() => {
        setIsCheckingAuth(true);
        localStorage.removeItem("bearer-token");

        const tokenInput = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        );
        setAntiforgeryToken(tokenInput ? tokenInput.value : "");

        fetch("/api/authentication/refresh-token", {
            method: "POST",
            credentials: "include",
        })
            .then((response) => response.json())
            .then((data) => {
                if (data?.accessToken) {
                    const redirectUrl = checkForXSS(
                        new URLSearchParams(window.location.search).get(
                            "ReturnUrl"
                        ) || "/"
                    );
                    safeRedirect(redirectUrl);
                } else {
                    setIsCheckingAuth(false);
                }
            })
            .catch(() => {
                setIsCheckingAuth(false);
            });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        setErrors([]);

        if (!username) {
            setRequestInProgress(false);
            return;
        }

        setRequestInProgress(true);

        const formData = { Username: username };

        const submitForgotPasswordRequest = async () => {
            try {
                const result = await requestWithHeaders(
                    "/api/account/forgot-password",
                    "POST",
                    formData,
                    {
                        "X-XSRF-TOKEN": antiforgeryToken,
                    }
                );
                if (result.response && result.response.ok) {
                    setEmailSent(true);
                } else {
                    const data =
                        (result && result.error && result.error.data) || {};
                    setErrors(data.errors || ["Request failed."]);
                }
            } catch (error) {
                setErrors(["Request failed."]);
            } finally {
                setRequestInProgress(false);
            }
        };

        submitForgotPasswordRequest();
    };

    const tryAgain = () => {
        setUsername("");
        setEmailSent(false);
        setSubmitted(false);
        setErrors([]);
    };

    if (isCheckingAuth) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Loading enabled={true} spinnerText="Loading..." />
            </div>
        );
    }

    return (
        <div className="login-page-wrapper">
            <div id="forgot-password-block" className="login-block-container">
                {!emailSent ? (
                    <>
                        <div className="login-block-header">
                            <img
                                className="logo"
                                src="/images/logo.svg"
                                alt="Logo"
                            />
                            <div className="description">
                                <span>
                                    To reset your password, please fill in the
                                    form and click the button below to receive
                                    an email with a reset link if an associated
                                    account exists.
                                </span>
                            </div>
                            {errors.length > 0 && (
                                <div className="errors">
                                    {errors.map((err, i) => (
                                        <p key={i}>{err}</p>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="login-block-body">
                            <form
                                method="post"
                                noValidate
                                onSubmit={handleSubmit}
                                autoComplete="off"
                            >
                                <div className="lm-input-group">
                                    <input
                                        type="text"
                                        name="username"
                                        spellCheck={false}
                                        autoComplete="off"
                                        required
                                        value={username}
                                        onChange={(e) =>
                                            setUsername(e.target.value)
                                        }
                                        disabled={requestInProgress}
                                        className={
                                            submitted && !username
                                                ? "has-error"
                                                : ""
                                        }
                                    />
                                    <span className="highlight"></span>
                                    <span className="bar"></span>
                                    <label htmlFor="username">Username</label>
                                    <span className="error">
                                        {submitted &&
                                            !username &&
                                            "The username field is required."}
                                    </span>
                                </div>
                                <button
                                    type="submit"
                                    className={`lm-btn primary sign-in-btn${
                                        requestInProgress ? " loading" : ""
                                    }`}
                                    disabled={requestInProgress}
                                >
                                    <span className="btn-label">
                                        Send Email
                                    </span>
                                    <LmLoader />
                                </button>
                            </form>
                        </div>

                        <div className="login-block-footer">
                            <Link to="/Account/Login" className="lm-link">
                                <span>Back to Sign In</span>
                            </Link>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="login-block-header">
                            <img
                                className="logo"
                                src="/images/logo.svg"
                                alt="Logo"
                            />
                        </div>

                        <div className="login-block-body">
                            <div className="description">
                                <p>
                                    Please check your email to reset your
                                    password.
                                </p>
                                <p>
                                    Didn't receive anything?
                                    <br />
                                    Click the button below to try again.
                                </p>
                            </div>
                            <button
                                type="button"
                                className="lm-btn primary sign-in-btn"
                                onClick={tryAgain}
                            >
                                <span className="btn-label">Try Again</span>
                            </button>
                        </div>

                        <div className="login-block-footer">
                            <Link to="/account/login" className="lm-link">
                                <span>Back to Sign In</span>
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
